import React from "react";
import * as Mui from "@mui/material";
import ListAltIcon from "@mui/icons-material/ListAlt";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { designColors, StatCard } from "services/constants/designTokens";
import { canonicalStatus } from "./shiftCorrectionApproveHelpers";

// Same accent/tint mapping as AttendanceCorrectionStatusCards, plus a
// Cancelled card — this mock dataset (see shiftCorrectionApproveHelpers)
// carries a Cancelled status, the same as My Zone's own Shift Change screen.
const STATUS_CARD_DEFS = [
  { key: "Pending", label: "Pending", icon: AccessTimeIcon, accent: "#F97316", tint: "#FFF7ED" },
  { key: "Approved", label: "Approved", icon: CheckCircleOutlineIcon, accent: "#16A34A", tint: "#EAFBF1" },
  { key: "Rejected", label: "Rejected", icon: HighlightOffIcon, accent: "#EF4444", tint: "#FEF2F2" },
  {
    key: "Cancelled",
    label: "Cancelled",
    icon: RemoveCircleOutlineIcon,
    accent: designColors.slate600,
    tint: designColors.slate100,
  },
];

const ALL_CARD_DEF = { key: "All", label: "All", icon: ListAltIcon, accent: "#1D4ED8", tint: "#EEF4FF" };

export const canonicalShiftCorrectionStatus = canonicalStatus;

// Single source of truth for a status's accent/tint pair, shared by these
// cards and ShiftCorrectionDetailPanel's header chip.
export const shiftCorrectionStatusVisual = (status) => {
  const canonical = canonicalStatus(status);
  return (
    STATUS_CARD_DEFS.find((card) => card.key === canonical) || {
      key: canonical,
      accent: designColors.slate600,
      tint: designColors.slate100,
    }
  );
};

export const ShiftCorrectionStatusCards = ({ counts, activeFilter, onCardClick }) => {
  const totalCount = Object.values(counts || {}).reduce((sum, count) => sum + (count || 0), 0);

  return (
    <Mui.Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
        "@media (max-width:599.95px)": {
          gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
          "& > :last-child:nth-child(odd)": { gridColumn: "1 / -1" },
        },
        gap: 1.5,
        mb: 2,
      }}
    >
      {[ALL_CARD_DEF, ...STATUS_CARD_DEFS].map((card) => {
        const isAll = card.key === "All";
        return (
          <StatCard
            activeBorder
            key={card.key}
            icon={card.icon}
            title={card.label}
            value={isAll ? totalCount : counts?.[card.key] || 0}
            accent={card.accent}
            tint={card.tint}
            isActive={isAll ? !activeFilter : activeFilter === card.key}
            onClick={onCardClick ? () => onCardClick(card.key) : undefined}
          />
        );
      })}
    </Mui.Box>
  );
};
